import { ObservableArray, View } from "binder"
import { WorkingShiftEditorViewModel } from "./workingShiftEditor-viewModel"
import { TimeSelectorViewModel } from "uicomponents";
import { TimePart } from "src/uicomponents/components/timeSelector/timeSelector-viewModel";

export class WorkingShiftEditorView extends View<WorkingShiftEditorViewModel> {
    GetViewUniqueId(): string {
        return "V-5AD5E0F9-2F80-430C-9F24-856C3C231CA2"
    }
    loadHtml(): string {
        let element = require('./workingShiftEditor.html').default;
        let style = require('./workingShiftEditor.less');
        return element;
    }
    constructor() {
        super();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set shiftName(v: string) { this._shiftName = v; } public get shiftName(): string { return this._shiftName; } private _shiftName: string;
    
    public set startTime(v: string) { this._startTime = v; } public get startTime(): string { return this._startTime; } private _startTime: string;
    public set endTime(v: string) { this._endTime = v; } public get endTime(): string { return this._endTime; } private _endTime: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    back() {
        this.dataContext.back();
    }

    save() {
        this.dataContext.save();
    }
}
